import { Action } from "../../../libs/redux/action";
import { payrollFileDefaultState, PayrollFileState } from "../state";
import {
    CLEAR_PAYROLL_FILE,
    CLOSE_PAYROLL_FILE_ERROR_MODAL,
    DOWNLOAD_PAYROLL_TEMPLATE_FILE,
    DOWNLOAD_PAYROLL_TEMPLATE_FILE_DONE,
    GET_PAYROLL_FILE_PROCESS,
    GET_PAYROLL_FILE_PROCESS_DONE,
    SHOW_PAYROLL_FILE_ERROR_MODAL,
    UPLOAD_PAYROLL_FILE,
    UPLOAD_PAYROLL_FILE_DONE,
} from "../constants";
import {
    PayrollFileProcessValues,
    PayrollFileUploadedValue,
    PayrollFileValues,
} from "../../../containers/quotation/types/payroll-file";
import {
    COLUMN_ERRORS,
    COLUMN_NAMES,
    ERROR_MODALS,
    ErrorFormats,
    ERRORS_LIST,
    FORMAT_ERRORS,
} from "../../../containers/payroll-error-modal/constants/payroll-errors";
import { AjaxError } from "rxjs/ajax";

export class PayrollFileDownloadTemplateFile extends Action<
    void,
    PayrollFileState
> {
    readonly type = DOWNLOAD_PAYROLL_TEMPLATE_FILE;

    reducer(state: PayrollFileState): PayrollFileState {
        return {
            ...state,
        };
    }
}

export class PayrollFileDownloadTemplateFileDone extends Action<
    Error | PayrollFileValues,
    PayrollFileState
> {
    readonly type = DOWNLOAD_PAYROLL_TEMPLATE_FILE_DONE;

    reducer(state: PayrollFileState): PayrollFileState {
        if (this.error) {
            return {
                ...state,
            };
        }

        const file = this.payload as PayrollFileValues;

        return {
            ...state,
            file: file.encodeByte as string,
        };
    }
}

export class PayrollFileUpload extends Action<
    { fileName: string; fileContent: string; now?: Date },
    PayrollFileState
> {
    readonly type = UPLOAD_PAYROLL_FILE;

    reducer(state: PayrollFileState): PayrollFileState {
        const { fileName } = this.payload;
        return {
            ...state,
            loadingFile: true,
            initFileName: fileName,
        };
    }
}

export class PayrollFileUploadDone extends Action<
    Error | PayrollFileUploadedValue,
    PayrollFileState
> {
    readonly type = UPLOAD_PAYROLL_FILE_DONE;

    reducer(state: PayrollFileState): PayrollFileState {
        if (this.error) {
            const error = this.payload as Error;
            return {
                ...state,
                loadingFile: false,
                error: {
                    ...state.error,
                    messages: [error.message],
                },
            };
        }

        const { fileName } = this.payload as PayrollFileUploadedValue;

        return {
            ...state,
            filePath: fileName,
            error: {
                ...state.error,
                messages: null,
                typeModal: null,
            },
        };
    }
}

export class GetPayrollFileProcess extends Action<
    PayrollFileUploadedValue,
    PayrollFileState
> {
    readonly type = GET_PAYROLL_FILE_PROCESS;

    reducer(state: PayrollFileState): PayrollFileState {
        const { fileName } = this.payload;
        return {
            ...state,
            fileName,
        };
    }
}

export class GetPayrollFileProcessDone extends Action<
    Error | PayrollFileProcessValues,
    PayrollFileState
> {
    readonly type = GET_PAYROLL_FILE_PROCESS_DONE;

    reducer(state: PayrollFileState): PayrollFileState {
        if (this.error) {
            return {
                ...state,
                loadingFile: false,
                error: {
                    ...state.error,
                    messages: ["file couldn't be process"],
                },
                totalNumberOfWorkers: 0,
                totalAmountOfSalary: 0,
            };
        }

        const {
            fileName,
            totalAmountOfSalary,
            totalNumberOfWorkers,
            totalPayrollOfWorkers,
        } = this.payload as PayrollFileProcessValues;

        return {
            ...state,
            loadingFile: false,
            filePath: fileName,
            totalAmountOfSalary: totalAmountOfSalary,
            totalNumberOfWorkers: totalNumberOfWorkers,
            totalPayrollOfWorkers: totalPayrollOfWorkers,
        };
    }
}

export class ShowPayrollFileErrorModal extends Action<
    AjaxError,
    PayrollFileState
> {
    readonly type = SHOW_PAYROLL_FILE_ERROR_MODAL;

    reducer(state: PayrollFileState): PayrollFileState {
        const {
            status,
            response: { localizedMessage },
        } = this.payload;

        let typeModal: ERROR_MODALS = null;
        const errorMessages = [];

        if (status === 409 && localizedMessage) {
            typeModal = ERROR_MODALS.INCORRECT_EXTENSION;
            errorMessages.push(localizedMessage);

            return {
                ...state,
                error: {
                    isOpen: true,
                    typeModal: typeModal,
                    messages: errorMessages,
                },
            };
        }

        const {
            response: {
                errorFileProcess: { errorCode },
            },
        } = this.payload;

        const stoppersList =
            (this.payload.response.errorFileProcess.errorStopper &&
                this.payload.response.errorFileProcess.errorStopper
                    .stoppersList) ||
            [];

        const errorFormatList =
            (this.payload.response.errorFileProcess.errorFormat &&
                this.payload.response.errorFileProcess.errorFormat
                    .errorFormatList) ||
            [];

        if (errorCode === "E001") {
            typeModal = ERROR_MODALS.FORMAT_ERRORS;
            errorMessages.push("Entre 1 a 200 trabajadores por planilla");
            errorMessages.push("Edades entre 18 a 60 años");
            errorMessages.push(
                "Salario entre S/ 40 a S/ 30 000 por trabajador"
            );

            return {
                ...state,
                error: {
                    isOpen: true,
                    typeModal: typeModal,
                    messages: errorMessages,
                },
            };
        }

        if (
            status === 409 &&
            errorCode === "E002" &&
            errorFormatList.length > 0
        ) {
            typeModal = ERROR_MODALS.FORMAT_COLUMNS_ERRORS;
            let columnFormatErrors: string[] = [];
            let formatErrors: string[] = [];
            let isEmpty = false;

            errorFormatList.forEach((error: ErrorFormats) => {
                if (
                    error.column === 0 &&
                    error.line === 0 &&
                    error.error.includes(FORMAT_ERRORS.EMPTY)
                ) {
                    isEmpty = true;
                }

                if (
                    error.error.includes(FORMAT_ERRORS.INVALID_DOCUMENT) ||
                    error.error.includes(FORMAT_ERRORS.EMPTY) ||
                    error.error.includes(FORMAT_ERRORS.INVALID_CHAR) ||
                    error.error.includes(FORMAT_ERRORS.DUPLICATED_DOCUMENT) ||
                    error.error.includes(FORMAT_ERRORS.INVALID_TYPE_DOCUMENT) ||
                    error.error.includes(FORMAT_ERRORS.INVALID_BIRTHDAY)
                ) {
                    columnFormatErrors.push(
                        ShowPayrollFileErrorModal.getColumnError(error.campo)
                    );
                }

                if (
                    error.error.includes(FORMAT_ERRORS.INVALID_AGE) ||
                    error.error.includes(FORMAT_ERRORS.INVALID_SALARY)
                ) {
                    formatErrors.push(
                        ShowPayrollFileErrorModal.getColumnError(error.error)
                    );
                }
            });

            formatErrors = formatErrors.reduce(
                (unique, item) =>
                    unique.includes(item) ? unique : [...unique, item],
                []
            );

            if (isEmpty) {
                formatErrors.push("Entre 1 a 200 trabajadores por planilla");
                formatErrors.push("Edades entre 18 a 60 años");
                formatErrors.push(
                    "Salario entre S/ 40 a S/ 30 000 por trabajador"
                );

                return {
                    ...state,
                    error: {
                        isOpen: true,
                        typeModal: ERROR_MODALS.FORMAT_ERRORS,
                        messages: formatErrors,
                    },
                };
            }

            if (formatErrors.length > 0) {
                return {
                    ...state,
                    error: {
                        isOpen: true,
                        typeModal: ERROR_MODALS.FORMAT_ERRORS,
                        messages: formatErrors,
                    },
                };
            }

            columnFormatErrors = columnFormatErrors.reduce(
                (unique, item) =>
                    unique.includes(item) ? unique : [...unique, item],
                []
            );

            return {
                ...state,
                error: {
                    isOpen: true,
                    typeModal: typeModal,
                    messages: columnFormatErrors,
                },
            };
        }

        const limitAge = stoppersList.some(
            (error: ERRORS_LIST) => error === ERRORS_LIST.WORKER_EXCEEDS_AGE
        );

        if (status === 409 && errorCode === "E003" && limitAge) {
            typeModal = ERROR_MODALS.FORMAT_ERRORS;
            errorMessages.push("Edades entre 18 a 60 años");
        }

        const limitSalary = stoppersList.some(
            (error: ERRORS_LIST) => error === ERRORS_LIST.WORKER_EXCEEDS_SALARY
        );

        if (status === 409 && errorCode === "E003" && limitSalary) {
            typeModal = ERROR_MODALS.FORMAT_ERRORS;
            errorMessages.push(
                "Salario entre S/ 40 a S/ 30 000 por trabajador"
            );
        }

        const limitWorkers = stoppersList.some(
            (error: ERRORS_LIST) => error === ERRORS_LIST.MORE_THAN_200_WORKERS
        );

        if (errorCode === "E003" && limitWorkers) {
            errorMessages.push("Máximo 200 trabajadores por planilla");
            typeModal = ERROR_MODALS.LIMIT_WORKERS;
        }

        return {
            ...state,
            error: {
                isOpen: true,
                typeModal: typeModal,
                messages: errorMessages,
            },
        };
    }

    private static getColumnError(column: string): string {
        if (column.includes(COLUMN_NAMES.DOCUMENT_NUMBER)) {
            return COLUMN_ERRORS[COLUMN_NAMES.DOCUMENT_NUMBER];
        }
        if (column.includes(COLUMN_NAMES.LAST_NAME)) {
            return COLUMN_ERRORS[COLUMN_NAMES.LAST_NAME];
        }
        if (column.includes(COLUMN_NAMES.TYPE_DOCUMENT)) {
            return COLUMN_ERRORS[COLUMN_NAMES.TYPE_DOCUMENT];
        }
        if (column.includes(COLUMN_NAMES.SALARY)) {
            return COLUMN_ERRORS[COLUMN_NAMES.SALARY];
        }
        if (column.includes(COLUMN_NAMES.SECOND_LAST_NAME)) {
            return COLUMN_ERRORS[COLUMN_NAMES.SECOND_LAST_NAME];
        }
        if (column.includes(COLUMN_NAMES.BIRTHDAY)) {
            return COLUMN_ERRORS[COLUMN_NAMES.BIRTHDAY];
        }
        if (column.includes(COLUMN_NAMES.NAME)) {
            return COLUMN_ERRORS[COLUMN_NAMES.NAME];
        }
        if (column.includes(COLUMN_NAMES.NATIONALITY)) {
            return COLUMN_ERRORS[COLUMN_NAMES.NATIONALITY];
        }
        if (column.includes(FORMAT_ERRORS.INVALID_AGE)) {
            return "Edades entre 18 a 60 años";
        }
        if (column.includes(FORMAT_ERRORS.INVALID_SALARY)) {
            return "Salario entre S/ 40 a S/ 30 000 por trabajador";
        }
    }
}

export class ClosePayrollFileErrorModal extends Action<void, PayrollFileState> {
    readonly type = CLOSE_PAYROLL_FILE_ERROR_MODAL;

    reducer(state: PayrollFileState): PayrollFileState {
        return {
            ...state,
            error: {
                ...state.error,
                isOpen: false,
            },
        };
    }
}

export class ClearPayrollFile extends Action<void, PayrollFileState> {
    readonly type = CLEAR_PAYROLL_FILE;

    reducer(state: PayrollFileState): PayrollFileState {
        return {
            ...state,
            ...payrollFileDefaultState,
        };
    }
}
